(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2559],{

/***/ 5678:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-with-us",
      function () {
        return __webpack_require__(19259);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_GlobalLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./customHooks/useSignIn/useSignIn.ts
var useSignIn = __webpack_require__(37394);
// EXTERNAL MODULE: ./utils/memberAppSignInRedirect.ts
var memberAppSignInRedirect = __webpack_require__(37918);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/icons/BurgerMenuCloseIcon.tsx

var BurgerMenuCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#A)",
                "fill-rule": "evenodd",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.497 3.493a.5.5 0 0 1 .707 0l16.305 16.305a.5.5 0 0 1-.707.707L3.497 4.2a.5.5 0 0 1 0-.707z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.502 3.491a.5.5 0 0 1 0 .707L4.198 20.503a.5.5 0 1 1-.707-.707L19.795 3.491a.5.5 0 0 1 .707 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_BurgerMenuCloseIcon = (BurgerMenuCloseIcon);

// EXTERNAL MODULE: ./customHooks/useAuth/AuthProvider.tsx + 1 modules
var AuthProvider = __webpack_require__(52961);
;// CONCATENATED MODULE: ./blocks/Header/Header.tsx




















var Header = function() {
    var router = (0,next_router.useRouter)();
    var join_us_text = (0,useLocalised/* default */.Z)(translationKeys.join_us);
    var sign_in_text = (0,useLocalised/* default */.Z)(translationKeys.sign_in);
    var ref = (0,react.useContext)(useSignIn/* SignInContext */.f), setSignInState = ref.setState;
    var ref1 = (0,react.useContext)(useDialogue/* DialogueContext */.$), openDialogue = ref1.openDialogue, closeDialogue = ref1.closeDialogue, dialogueState = ref1.dialogueState;
    var isMobileMenuOpen = dialogueState.presentedDialogueType === constants/* MOBILE_MENU_DIALOGUE */.uN;
    var handleClickOnSignIn = (0,react.useCallback)(function() {
        var hotelRedirect = (0,memberAppSignInRedirect/* getHotelMemberSignInRedirectFromRouter */.e)(router.pathname, router.query);
        setSignInState(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                redirectTo: hotelRedirect
            });
        });
        openDialogue(constants/* SIGN_IN_DIALOG */.jt);
    }, [
        openDialogue,
        router.pathname,
        router.query,
        setSignInState
    ]);
    var handleClickOnJoinUs = (0,react.useCallback)(function() {
        openDialogue(constants/* JOIN_US_DIALOG_STEP_1 */.le);
    }, [
        openDialogue
    ]);
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_MENU_DIALOGUE */.uN);
    }, [
        openDialogue
    ]);
    var signedIn = (0,AuthProvider/* useAuth */.a)().signedIn;
    var homePage = signedIn ? constants/* navigationPaths.WEB_APP_HOMEPAGE */.aY.WEB_APP_HOMEPAGE : constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Hotels",
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Membership",
                            path: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Gift cards",
                            path: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "MyLER",
                            path: constants/* navigationPaths.INDEPENDENT_TRAVEL_AGENT */.aY.INDEPENDENT_TRAVEL_AGENT,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Journal",
                            path: constants/* navigationPaths.TRAVEL_JOURNAL_ARTICLES */.aY.TRAVEL_JOURNAL_ARTICLES,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "burger-icon",
                    children: [
                        !isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleBurgerMenuClick,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                        }),
                        isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeDialogue,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BurgerMenuCloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            className: "header-text-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-rigth",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: join_us_text,
                            onClick: handleClickOnJoinUs,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-join_us_text_button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: sign_in_text,
                            onClick: handleClickOnSignIn,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-navigation-item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(53114);
;// CONCATENATED MODULE: ./utils/header.ts
function formatCanonicalUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return url;
    }
    return url.replace(/^https?:\/\/(www\.)?/, "https://");
}
// gets first sentence or two from some copy
function getDescriptionFromContent(text) {
    if (!text) {
        return "";
    }
    var sentences = text.match(/[^.!?]+[.!?](?=\s+|$)/g);
    if (!sentences) {
        return text;
    }
    // help avoid splitting on common abbreviations  
    var abbreviations = /\b(?:[A-Z]\.|(?:[A-Z]\w{0,2}\.){2,}|e\.g\.|i\.e\.)/i;
    var combinedText = sentences[0].trim();
    // sensible minimum length for description
    if (combinedText.length > 90) {
        return combinedText;
    }
    for(var i = 1; i < sentences.length; i++){
        if (abbreviations.test(sentences[i])) {
            combinedText += " " + sentences[i].trim();
            continue;
        }
        combinedText += " " + sentences[i].trim();
        if (combinedText.length > 90) {
            return combinedText;
        }
    }
    return text;
}

;// CONCATENATED MODULE: ./blocks/Layouts/GlobalLayout.tsx



//Components



var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Little Emperors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    metaData.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: metaData.type
                    }),
                    metaData.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaData.image
                    }),
                    metaData.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metaData.author
                    }),
                    metaData.publishedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: metaData.publishedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: formatCanonicalUrl(metaData.url)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var Layouts_GlobalLayout = (GlobalLayout);


/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ FILLED_BUTTON_TYPE_DARK; },
/* harmony export */   "II": function() { return /* binding */ LINK_BUTTON_TYPE; },
/* harmony export */   "ME": function() { return /* binding */ FILLED_BUTTON_TYPE; },
/* harmony export */   "Wr": function() { return /* binding */ OUTLINED_BUTTON_TYPE_DARK; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95475);



var LINK_BUTTON_TYPE = "LINK_BUTTON_TYPE";
var FILLED_BUTTON_TYPE = "FILLED_BUTTON_TYPE";
var FILLED_BUTTON_TYPE_DARK = "FILLED_BUTTON_TYPE_DARK";
var OUTLINED_BUTTON_TYPE_DARK = "OUTLINED_BUTTON_TYPE_DARK";
var Button = function(param) {
    var title = param.title, onClick = param.onClick, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? FILLED_BUTTON_TYPE : _buttonType, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className, htmlAttributes = param.htmlAttributes;
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isLoading) {
            return;
        }
        onClick();
    }, [
        isLoading,
        onClick
    ]);
    var getClass = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var classNameArray = [];
        var inititalClassName = "button-body-filled";
        switch(buttonType){
            case LINK_BUTTON_TYPE:
                inititalClassName = "button-body-link";
                break;
            case FILLED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-filled-dark";
                break;
            case OUTLINED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-outlined-dark";
            default:
                break;
        }
        classNameArray.push(inititalClassName);
        if (className) {
            classNameArray.push(className);
        }
        return classNameArray.join(" ");
    }, [
        buttonType,
        className
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.type,
        onClick: handleOnClick,
        className: getClass(),
        "area-label": title,
        style: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.style,
        disabled: (htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.disabled) || false,
        children: [
            !isLoading && title,
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4093);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var BaseText = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, children = _param.children, _color = _param.color, color = _color === void 0 ? "black" : _color, weight = _param.weight, fontStyle = _param.fontStyle, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, align = _param.align, style = _param.style, isLink = _param.isLink, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "color",
        "weight",
        "fontStyle",
        "letterSpacing",
        "fontSize",
        "align",
        "style",
        "isLink",
        "className"
    ]);
    var colorStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var fontWeightStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeightFromString */ .J)(weight);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .getMarginFromProps */ .X)(rest);
    var joinedClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().baseText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link), isLink), className);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: joinedClassName,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            fontWeight: fontWeightStyle,
            fontStyle: fontStyle,
            color: colorStyle,
            textAlign: align,
            letterSpacing: letterSpacing,
            fontSize: fontSize
        }, marginStyle, style)
    }, rest), children);
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);




var Body = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Body);


/***/ }),

/***/ 36443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85392);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "h1" : _as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        as: as,
        className: (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[as]
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26926);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Small_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Small = function(_param) {
    var _xs = _param.xs, xs = _xs === void 0 ? false : _xs, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "xs"
    ]);
    var joinedClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().xs), xs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "small",
        className: joinedClassNames
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Small);


/***/ }),

/***/ 22538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "uT": function() { return /* reexport safe */ _Body__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _Small__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7117);
/* harmony import */ var _Small__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82096);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36443);





/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ getColorFromString; },
  "J": function() { return /* binding */ getFontWeightFromString; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/shared/constants.ts
var constants = __webpack_require__(55774);
;// CONCATENATED MODULE: ./components/text/constants.ts
var weights = {
    regular: 400,
    medium: 500,
    demiBold: 600
};

;// CONCATENATED MODULE: ./components/text/utils.ts



var getColorFromString = function(colorString) {
    var ref = (0,_sliced_to_array/* default */.Z)(colorString.split("-"), 2), colorName = ref[0], shade = ref[1];
    var color = shade ? constants/* colors */.O[colorName][shade] : constants/* colors */.O[colorString];
    return color ? color : constants/* colors.black */.O.black;
};
var getFontWeightFromString = function(weightString) {
    if (!weightString) {
        return null;
    }
    var weight = weights[weightString];
    return weight ? weight : weights.regular;
};


/***/ }),

/***/ 19259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ partner_with_us; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./blocks/partner-with-us/components/welcome-section/WelcomeSection.module.scss
var WelcomeSection_module = __webpack_require__(47153);
var WelcomeSection_module_default = /*#__PURE__*/__webpack_require__.n(WelcomeSection_module);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./assets/svg/union.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgUnion = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 74,
  height: 174,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.184 66.366c8.931-6.733 14.706-17.43 14.706-29.477C73.89 16.516 57.373 0 37 0S.11 16.516.11 36.89c0 12.046 5.775 22.743 14.706 29.476L.213 173.24h73.574L59.184 66.366Z",
  fill: "#000"
})));
/* harmony default export */ var union = (SvgUnion);
;// CONCATENATED MODULE: ./blocks/partner-with-us/components/welcome-section/WelcomeSection.tsx





var WelcomeSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (WelcomeSection_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(union, {
                alt: "Union icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WelcomeSection_module_default()).brandSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (WelcomeSection_module_default()).title,
                        children: "Vault"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (WelcomeSection_module_default()).subTitle,
                        children: "By Little emperors"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                as: "h1",
                className: (WelcomeSection_module_default()).introSection,
                children: [
                    "Our exclusive preferred partner programme ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                        className: "hideMobile"
                    }),
                    "designed for luxury hotels"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h2",
                className: (WelcomeSection_module_default()).description,
                children: "Vault ensures a premium experience for both our members and partner hotels, offering exceptional benefits that elevate your property's visibility and appeal. As a Vault partner, you'll also gain direct access to our MyLER community of Independent Travel Advisors, further enhancing your reach and driving more bookings."
            })
        ]
    });
};
/* harmony default export */ var welcome_section_WelcomeSection = (WelcomeSection);

;// CONCATENATED MODULE: ./blocks/partner-with-us/components/welcome-section/index.ts


// EXTERNAL MODULE: ./blocks/partner-with-us/components/vault-benefits/VaultBenefits.module.scss
var VaultBenefits_module = __webpack_require__(30405);
var VaultBenefits_module_default = /*#__PURE__*/__webpack_require__.n(VaultBenefits_module);
;// CONCATENATED MODULE: ./assets/svg/big-arrow-right.svg
var big_arrow_right_path;
function big_arrow_right_extends() { return big_arrow_right_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, big_arrow_right_extends.apply(null, arguments); }

const SvgBigArrowRight = props => /*#__PURE__*/react.createElement("svg", big_arrow_right_extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 61,
  height: 16,
  fill: "none"
}, props), big_arrow_right_path || (big_arrow_right_path = /*#__PURE__*/react.createElement("path", {
  d: "M60.707 8.948a1 1 0 0 0 0-1.414L54.343 1.17a1 1 0 0 0-1.414 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM0 9.241h60v-2H0v2Z",
  fill: "#BAA57E"
})));
/* harmony default export */ var big_arrow_right = (SvgBigArrowRight);
// EXTERNAL MODULE: ./blocks/partner-with-us/components/vault-benefits/BenefitItem.module.scss
var BenefitItem_module = __webpack_require__(11165);
var BenefitItem_module_default = /*#__PURE__*/__webpack_require__.n(BenefitItem_module);
;// CONCATENATED MODULE: ./blocks/partner-with-us/components/vault-benefits/BenefitItem.tsx





var BenefitItem = function(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (BenefitItem_module_default()).benefitWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BenefitItem_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(big_arrow_right, {
                        alt: "Arrow pointing right"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h5",
                        weight: "demiBold",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BenefitItem_module_default()).description,
                children: description
            })
        ]
    });
};
/* harmony default export */ var vault_benefits_BenefitItem = (BenefitItem);

;// CONCATENATED MODULE: ./blocks/partner-with-us/components/vault-benefits/VaultBenefits.tsx





var VaultBenefits = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (VaultBenefits_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vault_benefits_BenefitItem, {
                title: "Premier benefits for hotel partners",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                    as: "h5",
                    weight: "regular",
                    children: [
                        "By joining Vault, your hotel will ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "stand out"
                        }),
                        " and benefit from complimentary marketing and social media exposure, driving ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "more bookings"
                        }),
                        " and",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "enhancing your reputation"
                        }),
                        " within our luxury network."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vault_benefits_BenefitItem, {
                title: "Flexible and hassle-free partnership",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                            as: "h5",
                            weight: "regular",
                            children: [
                                "Vault membership is simple and ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "cost-free"
                                }),
                                ", with all bookings seamlessly managed through our platform."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                            as: "h5",
                            weight: "regular",
                            children: "With a 12-month rolling term and easy exit options, Vault offers flexibility and peace of mind."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vault_benefits_BenefitItem, {
                title: "Connect with our MyLER network",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                            as: "h5",
                            weight: "regular",
                            children: [
                                "Vault offers ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "exclusive opportunities"
                                }),
                                " to engage with our growing MyLER community of Independent Travel Advisors. Leverage newsletters, webinars and FAM trips to showcase your property."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                            as: "h5",
                            weight: "regular",
                            children: [
                                "Additionally, gain ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "special recognition"
                                }),
                                " through our ‘MyLER High Club’, further",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "enhancing your visibility"
                                }),
                                " within our MyLER community."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var vault_benefits_VaultBenefits = (VaultBenefits);

;// CONCATENATED MODULE: ./blocks/partner-with-us/components/vault-benefits/index.ts


// EXTERNAL MODULE: ./blocks/partner-with-us/PartnerWithUs.module.scss
var PartnerWithUs_module = __webpack_require__(47940);
var PartnerWithUs_module_default = /*#__PURE__*/__webpack_require__.n(PartnerWithUs_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./assets/partner-with-us/partner-with-us-body.png
/* harmony default export */ var partner_with_us_body = ({"src":"/_next/static/media/partner-with-us-body.aca0c86a.png","height":683,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAOVBMVEV0VEGEYVGJUjawgVNJMh/uw5JwRi7Svq6JSyJAMinjp21kOR80MS6ghGxVKxDOqYedk4pQSkd9XEg+b1WoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nAXBhwEAIAjAsKIg4Pb/Z01wd7+MwOws2g56VURagOabSfkQUgDYfyiGlwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
;// CONCATENATED MODULE: ./blocks/partner-with-us/PartnerWithUs.tsx










var PartnerWithUs = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (PartnerWithUs_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_section_WelcomeSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (PartnerWithUs_module_default()).heroImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    src: partner_with_us_body,
                    alt: "Partner with us hero image",
                    layout: "responsive"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vault_benefits_VaultBenefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (PartnerWithUs_module_default()).contactSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PartnerWithUs_module_default()).contactWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                            as: "h5",
                            children: [
                                "To find out more and to discuss your eligibility for this programme,\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (PartnerWithUs_module_default()).contactText,
                                    children: "please contact us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (PartnerWithUs_module_default()).container,
                            href: "mailto:".concat(constants/* emailAdresses.PARTNER_WITH_US */.mL.PARTNER_WITH_US),
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                as: "h5",
                                weight: "regular",
                                children: constants/* emailAdresses.PARTNER_WITH_US */.mL.PARTNER_WITH_US
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var partner_with_us_PartnerWithUs = (PartnerWithUs);

;// CONCATENATED MODULE: ./blocks/partner-with-us/index.ts


;// CONCATENATED MODULE: ./pages/partner-with-us/index.tsx





var PartnerWithUsHome = function(param) {
    var globalLayoutProps = param.globalLayoutProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partner_with_us_PartnerWithUs, {})
    }));
};
var __N_SSG = true;
/* harmony default export */ var partner_with_us = (PartnerWithUsHome);


/***/ }),

/***/ 37918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getHotelMemberSignInRedirectFromRouter; }
/* harmony export */ });
/**
 * When the user opens sign-in from a public hotel page, the member webapp expects
 * external-login?redirect=hotel/{numericId} (path after /ile/, no leading slash).
 */ function getHotelMemberSignInRedirectFromRouter(pathname, query) {
    if (pathname !== "/our-hotels/[idHotel]") {
        return undefined;
    }
    var raw = query.idHotel;
    var id = Array.isArray(raw) ? raw[0] : raw;
    if (typeof id !== "string" || !/^\d+$/.test(id)) {
        return undefined;
    }
    return "hotel/".concat(id);
}


/***/ }),

/***/ 47940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PartnerWithUs_container__So0bp","heroImage":"PartnerWithUs_heroImage__qV_ak","contactSection":"PartnerWithUs_contactSection__leLJA","contactWrapper":"PartnerWithUs_contactWrapper__4_7hU","contactText":"PartnerWithUs_contactText__0ntz1"};

/***/ }),

/***/ 11165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"benefitWrapper":"BenefitItem_benefitWrapper__VBvD_","title":"BenefitItem_title___zyK2","description":"BenefitItem_description__0Ddw6"};

/***/ }),

/***/ 30405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"VaultBenefits_container__4Vd_0"};

/***/ }),

/***/ 47153:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WelcomeSection_container__SyOEm","brandSection":"WelcomeSection_brandSection__IgS3t","title":"WelcomeSection_title__SzMut","subTitle":"WelcomeSection_subTitle__GBqQG","introSection":"WelcomeSection_introSection__w5CoD","description":"WelcomeSection_description__8NgCW"};

/***/ }),

/***/ 4093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseText":"BaseText_baseText__UdRof","link":"BaseText_link__iIUwY"};

/***/ }),

/***/ 85392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};

/***/ }),

/***/ 26926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};

/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,4520,9774,2888,179], function() { return __webpack_exec__(5678); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);